import(/* webpackMode: "eager" */ "/vercel/path0/components/ads/AdSlot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CategoryPills"] */ "/vercel/path0/components/layout/CategoryPills.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MaintenanceDialog"] */ "/vercel/path0/components/maintenance/MaintenanceDialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchBar"] */ "/vercel/path0/components/search/SearchBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocalizedFeed"] */ "/vercel/path0/components/stickers/LocalizedFeed.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/.pnpm/lucide-react@1.14.0_react@19.2.6/node_modules/lucide-react/dist/esm/Icon.mjs");
